import axios from "axios";

// Create a base Axios instance
const apiClient = axios.create({
  baseURL: process.env.REACT_APP_API_URL, // Base URL from .env
  headers: {
    "Content-Type": "application/json;charset=utf8",
    accept: "*/*",
  },
});

export default apiClient;
